module.exports = __webpack_public_path__ + "img/37_fineStaff_zyc.7d615d24.png";